import React, { Component } from 'react';
import ExamesProcedimentos from './ExamesProcedimentos';
import m from '@utils/strings';

class ExamesProcedimentosProntoSocorro extends Component {
    
    render() {
        return (
            <ExamesProcedimentos 
                pageTitle={m.TELA_EXAMES_PROCEDIMENTOS.TITULO_TELA_EXAMES_PROCEDIMENTOS_PS} 
                iconPath={"../images/procedimentos_ps.png"}
                tipoAtendimento={2}
            />
        );
    }
}

export default ExamesProcedimentosProntoSocorro;